// Servizio pagamenti marketplace (Stripe Connect) — lato frontend.
import { api, unwrap } from './client';

export const marketplacePaymentsService = {
  checkoutCancel: (orderId) => unwrap(api.post('/marketplace-payments/checkout/cancel', { order_id: orderId })),
  // partner (stakeholder)
  connectStatus: () => unwrap(api.get('/marketplace-payments/connect/status')),
  onboardingLink: (origin) => unwrap(api.post('/marketplace-payments/connect/onboarding-link', { origin })),
  dashboardLink: () => unwrap(api.post('/marketplace-payments/connect/dashboard-link')),
  pausePayments: () => unwrap(api.post('/marketplace-payments/connect/pause')),
  resumePayments: () => unwrap(api.post('/marketplace-payments/connect/resume')),
  // admin
  getConfig: () => unwrap(api.get('/marketplace-payments/admin/config')),
  updateConfig: (body) => unwrap(api.put('/marketplace-payments/admin/config', body)),
  listAccounts: () => unwrap(api.get('/marketplace-payments/admin/accounts')),
  adminOrders: (params = {}) => unwrap(api.get('/marketplace-payments/admin/orders', { params })),
  refundOrder: (orderId, amount = null, reason = '') =>
    unwrap(api.post('/marketplace-payments/admin/refund', { order_id: orderId, amount, reason })),
  // partner (incassi)
  stakeholderEarnings: () => unwrap(api.get('/marketplace-payments/stakeholder/earnings')),
  // checkout embedded (cliente)
  configPublic: () => unwrap(api.get('/marketplace-payments/config/public')),
  checkoutIntent: (redeemPoints = 0, shippingAddress = null) =>
    unwrap(api.post('/marketplace-payments/checkout/intent', {
      redeem_points: redeemPoints,
      shipping_address: shippingAddress || {},
    })),
  checkoutConfirm: (orderId) =>
    unwrap(api.post('/marketplace-payments/checkout/confirm', { order_id: orderId })),
};


